var _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDataCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 61,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.809,
    cy: 49.424,
    rx: 58.809,
    ry: 10.76,
    fill: "#F6F8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4 14.268h22.4M41.4 23.868h8M49.4 43.068H38.2a3.2 3.2 0 01-3.2-3.2v-35.2a3.2 3.2 0 013.2-3.2h22.675a3.2 3.2 0 012.261.936l6.127 6.127c.6.6.937 1.413.937 2.261v5.075",
    stroke: "#9BA7E9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2 44.4c6.186 0 11.2-5.014 11.2-11.2 0-6.186-5.014-11.2-11.2-11.2C62.014 22 57 27.014 57 33.2c0 6.186 5.014 11.2 11.2 11.2z",
    stroke: "#9BA7E9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgNoDataCircle;